<template>
  <div class="oi-donate">
    <DonationForm v-if="form === 'full'" />
    <ExternalDonationForm v-if="form === 'external'" />
    <ExternalEnDonationForm v-if="form === 'external-en'" />
    <LightDonationForm v-if="form === 'light' || form === 'light-external'" />
    <SubscriptionForm v-if="form === 'subscription'" />
    <CheckoutStep v-if="step === 'checkout' && checkoutType !== 'widget'" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DonationForm from './components/full-form/DonationForm.vue'
import ExternalDonationForm from './components/external-form/ExternalDonationForm.vue'
import ExternalEnDonationForm from './components/external-en-form/ExternalEnDonationForm.vue'
import LightDonationForm from './components/light-form/LightDonationForm.vue'
import SubscriptionForm from './components/subscription-form/SubscriptionForm.vue'
import CheckoutStep from './components/shared/CheckoutStep.vue'
import { CONFIGURABLE_PROPS } from './settings'

export default {
  props: ['settings'],
  components: { DonationForm, ExternalDonationForm, ExternalEnDonationForm, LightDonationForm, CheckoutStep, SubscriptionForm },
  computed: mapState({
    step: state => state.step,
    form: state => state.form,
    checkoutType: state => state.checkoutType
  }),
  methods: {
    modifySettings (settings) {
      let change = {}
      Object.keys(CONFIGURABLE_PROPS).forEach(prop => {
        if (settings[prop] !== undefined) {
          const path = CONFIGURABLE_PROPS[prop].split('.')
          if (path.length === 2) {
            if (!change[path[0]]) change[path[0]] = {}
            change[path[0]][path[1]] = settings[prop]
          } else {
            change[path[0]] = settings[prop]
          }
        }
      })

      if (settings.form === 'external') {
        if (!change.donation) change.donation = {}
        change.donation.method = 'stripe'
        change.donation.sum = 50
        change.donation.currency = 'EUR'
      }

      if (settings.form === 'external-en') {
        if (!change.donation) change.donation = {}
        change.language = 'en'
        change.donation.method = 'stripe'
        change.donation.sum = 40
        change.donation.currency = 'EUR'
      }

      this.$store.dispatch('setConfiguration', change)
    },
    finishTransaction (success) {
      const successFn = this.settings.onSuccess
      const failFn = this.settings.onFail
      if (success) {
        if (successFn) successFn.call()
      } else {
        if (failFn) failFn.call()
      }
    }
  },
  beforeMount: function () {
    this.modifySettings(this.settings)
    this.$store.dispatch('setClientData')
  }
}
</script>

<style>
@font-face {
  font-family: "CoFo Sans";
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  src: url("./assets/fonts/CoFoSans-Regular.otf") format("opentype");
}

@font-face {
  font-family: "CoFo Sans";
  font-weight: 400;
  font-style: italic;
  font-display: auto;
  src: url("./assets/fonts/CoFoSans-RegularItalic.otf") format("opentype");
}

@font-face {
  font-family: "CoFo Sans";
  font-weight: 500;
  font-style: normal;
  font-display: auto;
  src: url("./assets/fonts/CoFoSans-Medium.otf") format("opentype");
}

@font-face {
  font-family: "CoFo Sans";
  font-weight: 800;
  font-style: normal;
  font-display: auto;
  src: url("./assets/fonts/CoFoSans-Black.otf") format("opentype");
}

.oi-donate a {
  color: #ef4e23!important;
}
.oi-donate .donate {
  width: 100%;
}
.oi-donate .donate {
  color: #fff!important;
  background-color: #ef4e23!important;
  border: 1px solid #ef4e23!important;
}
.oi-donate .donate:hover,
.oi-donate .donate:focus {
  color: #ef4e23!important;
  border: 1px solid #ef4e23!important;
  background: #fff!important;
}
.oi-donate input[type=email]:focus,
.oi-donate input[type=number]:focus,
.oi-donate input[type=text]:focus,
.oi-donate input:focus,
.oi-donate select:focus,
.oi-donate textarea:focus {
  border-color:#ef4e23!important;
}
.oi-donate input.error {
  border-color: #F44336!important;
}
.oi-donate small.help {
  display: block;
  font-size: 12px;
  line-height: 14px;
  margin: 5px 0 8px;
}
.oi-donate small.help.error {
  color: #F44336;
}
</style>
